import { useEffect } from "react";

const GoogleAnalytics = () => {
	useEffect(() => {
		const consent = localStorage.getItem("cookie_consent");

		if (consent === "true" && !window.gaLoaded) {
			window.gaLoaded = true; // Evita caricamenti multipli

			// Iniettare lo script di Google Tag Manager dinamicamente
			const script = document.createElement("script");
			script.async = true;
			script.src = "https://www.googletagmanager.com/gtag/js?id=G-WH57CKCKLG";
			document.head.appendChild(script);

			// Inizializzare Google Analytics dopo il caricamento dello script
			script.onload = () => {
				window.dataLayer = window.dataLayer || [];
				function gtag() {
					window.dataLayer.push(arguments);
				}
				window.gtag = gtag;
				gtag("js", new Date());
				gtag("config", "G-WH57CKCKLG");
			};
		}
	}, []);

	return null;
};

export default GoogleAnalytics;
